import React, { Component } from 'react';
import FaArrowLeft from 'react-icons/lib/fa/arrow-left';
import FaArrowRight from 'react-icons/lib/fa/arrow-right';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Form, Field } from 'react-final-form';

import moment from 'moment';
import { map, merge, filter, forEachObjIndexed } from 'ramda';
import * as actionCreators from '../store/actions';
import NavLink from '../helpers/navlink';

export class DatePicker extends Component {
  constructor() {
    super();
    this.prevDate = this.prevDate.bind(this);
    this.nextDate = this.nextDate.bind(this);
    this.format = "YYYY-MM-DD";
  }
  prevDate() {
    const m = moment(this.props.date, this.format).clone().subtract(1, 'days');
    this.props.onChange(m.format(this.format));
  }
  nextDate() {
    const m = moment(this.props.date, this.format).clone().add(1, 'days');
    this.props.onChange(m.format(this.format));
  }
  render() {
    const { date } = this.props;
    // <FaArrowLeft onClick={this.prevDate} />
    // <FaArrowRight onClick={this.nextDate}/>
    return (
      <h2 className="d-flex justify-content-between align-items-baseline">
        <div><FaArrowLeft onClick={this.prevDate} /></div>
        <div>{moment(date, this.format).format(this.props.displayFormat)}</div>
        <div><FaArrowRight onClick={this.nextDate}/></div>
      </h2>
    );
  }
}

class AppointmentFormInner extends Component {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
          <Field className="form-control" name="name" validate={required}>
            {({ input, meta }) => (
               <div>
                 <input className="form-control" {...input} placeholder="Name" />
                 {meta.error && meta.touched && <span>{meta.error}</span>}
               </div>
             )}
          </Field>
          <Field className="form-control" name="phone" validate={composeValidators(required)}>
            {({ input, meta }) => (
               <div>
                 <input className="form-control" {...input} type="text" placeholder="Phone Number" />
                 {meta.error && meta.touched && <span>{meta.error}</span>}
               </div>
             )}               
          </Field>
          <button disabled={this.props.submitting} onClick={this.props.onDone} className="btn btn-secondary">
            Cancel Edit
          </button>
          <button type="submit" disabled={this.props.submitting || this.props.pristine}
            className="btn btn-primary">
            Save
          </button>
          
      </form>
    )
  }
}

class AppointmentFormComponentInner extends Component {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this)
  }
  onSubmit(form) {
    if (form.name === '' && form.type === '') {
      form = merge(form, {type: "available"});
    } else {
      form = merge(form, {type: "booked"});
    }
    
    const promise = this.props.updateAppointment(form);
    if (this.props.onDone) {
      promise.then(this.props.onDone);
    }

  }
  render() {
    const {...rest} = this.props;
    return (<Form onSubmit={this.onSubmit} component={AppointmentFormInner} initialValues={this.props.appointment} {...rest}/>);
  }
}
const AppointmentFormComponent = connect((state) => ({}), actionCreators)(AppointmentFormComponentInner);

class Appointment extends Component {
  constructor() {
    super();
    this.state = {editing: false};
    this.setEditing = this.setEditing.bind(this);
    this.clearEditing = this.clearEditing.bind(this);
  }
  setEditing(e) {
    this.setState({editing: true});
  }
  clearEditing() {
    this.setState({editing: false});
  }
  render() {
    const appt = this.props.appointment;
    const date = moment(appt.time).format("h:mm a");
    var body;
    
    if (this.state.editing) {
      body = <div>{date}<AppointmentFormComponent onDone={this.clearEditing} appointment={appt}/></div>;
      
    } else {
      switch (appt.type) {
        case 'available':
          body = <div>{date} Available</div>;
          break;
        case 'booked':
          body = <div>{date} {appt.name} {appt.phone}</div>
          break;
        case 'walkin':
          body = <div>{date} Walk-in</div>;
          break;
        default:
          body = <div>Error</div>
      }
    }
    return (
      <li className="list-group-item" onDoubleClick={this.setEditing}>{body}</li>
    );
  }
}

class Chunk extends Component {
  render() {
    const {chunk} = this.props;
    const {appointments} = chunk;
    return (<div className="card" style={{marginBottom: "1rem"}}>
        <div className="card-header">
          {chunk.name}
        </div>
        <ul className="list-group list-group-flush">
          {appointments.map((appt) => (<Appointment key={appt.id} appointment={appt} />))}
        </ul>
    </div>);
  }
}

class Nav extends Component {
  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <span className="navbar-brand">Calendar</span>
        
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
              <NavLink to="/calendar/booking">Booking</NavLink>
              <NavLink to="/calendar/rebooking">Rebooking</NavLink>
              <NavLink to="/calendar/scheduling">Scheduling</NavLink>
          </ul>
        </div>
      </nav>
    );
  }
}

class DayComponent extends Component {
  constructor() {
    super();
    this.state = { day: moment().format('YYYY-MM-DD') };
    this.dateChange = this.dateChange.bind(this);
  }
  componentWillMount() {
    this.dateChange(this.state.day);
  }
  dateChange(newDate) {
    this.setState(merge(this.state, {day: newDate}));
    this.props.fetchCalendarDay(newDate);
    if (this.props.onDateChange) {
      this.props.onDateChange(newDate);
    }
  }
  render() {
    //const chunks = this.props.chunks[this.state.day] || [];
    const {appointments} = this.props;
    const chunksMap = filter( (chunk) => chunk.date === this.state.day, this.props.chunks || [] );
    const chunksList = [];
    forEachObjIndexed( (val) => chunksList.push(val), chunksMap );
    const chunksWithAppointments = map(
      (chunk) => merge(chunk, {appointments: map((apptId) => appointments[apptId], chunk.appointments)}),
      chunksList
    );
    return (
      <div className="col-6">
        <DatePicker date={this.state.day} onChange={this.dateChange} displayFormat="ddd, MMM Do, YYYY" />
        <div>
          {chunksWithAppointments.map(chunk => (<Chunk key={chunk.id} chunk={chunk} />))}
        </div>
      </div>
    );
  }
}

const selector = (state) => ({chunks: state.calendar.chunks, appointments: state.calendar.appointments});
export const Day = connect(selector, actionCreators)(DayComponent);

class Booking extends Component {
  render() {
    return (
      <div className="row">
        <Day />
      </div>
    );
  }
}

class Rebooking extends Component {
  render() { return (
    <div className="row">
      <Day />
      <Day />
    </div>
  );
  }
}

const parseTime = (time) => {
  if (!time) { return null; }
  const m = time.match(/(\d+)(:(\d\d))?\s*([ap]?)/i);
  if (!m) { return null; }
  var hour = parseInt(m[1], 10);
  const minute = parseInt(m[3] || 0, 10);
  if ((hour < 12) && (m[4] === 'p' || m[4] === 'P')) {
    hour += 12
  }
  if ((0 <= hour && hour <= 23) && (0 <= minute && minute <= 59)) {
    return ({ hour: hour, minute: minute });
  } else {
    return null;
  }
};
const validateTime = (time) => {
  const t = parseTime(time);
  if (t) {
    return undefined;
  } else {
    return "Must be a valid time";
  }
};
const required = value => (value ? undefined : "Required");
const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

class AddShiftInnerForm extends Component {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <div className="form-group">
          <Field className="form-control" name="name" validate={required}>
            {({ input, meta }) => (
               <div>
                 <input className="form-control" {...input} placeholder="Shift Label" />
                 {meta.error && meta.touched && <span>{meta.error}</span>}
               </div>
             )}
          </Field>
          <Field className="form-control" name="start" validate={composeValidators(required, validateTime)}>
            {({ input, meta }) => (
               <div>
                 <input className="form-control" {...input} type="text" placeholder="Start Time" />
                 {meta.error && meta.touched && <span>{meta.error}</span>}
               </div>
             )}
          </Field>
          <Field className="form-control" name="end" validator={composeValidators(required, validateTime)}>
            {({ input, meta }) => (
               <div>
                 <input className="form-control" {...input} type="text" placeholder="End Time" />
                 {meta.error && meta.touched && <span>{meta.error}</span>}
               </div>
             )}
          </Field>
          <Field className="form-control" name="duration" validator={composeValidators(required)}>
            {({ input, meta }) => (
               <div>
                 <input className="form-control" {...input} type="text" placeholder="Duration" />
                 {meta.error && meta.touched && <span>{meta.error}</span>}
               </div>
             )}
          </Field>
          <Field className="form-control" name="shift-type" component="select">
            <option value="available">Appointments</option>
            <option value="walkin">Walk-ins</option>
          </Field>
          <button type="submit" disabled={this.props.submitting || this.props.pristine}
            className="btn btn-primary">
            Submit
          </button>
        </div>
      </form>
    );
  }
}

class AddShiftFormComponent extends Component {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
  }
  onSubmit(form) {
    this.props.addShift(merge(form, {date: this.props.date,
                                     start: parseTime(form.start),
                                     end: parseTime(form.end)}));
  }
  parseTime(time) {
    
  }
  render() {
    const {...rest} = this.props;
    return (<Form onSubmit={this.onSubmit} component={AddShiftInnerForm} initialValues={{"shift-type": "available"}} {...rest}/>);
  }
}

const AddShiftForm = connect(() => ({}), actionCreators)(AddShiftFormComponent);

class Scheduling extends Component {
  constructor() {
    super();
    this.state = {date:''};
    this.onDateChange = this.onDateChange.bind(this);
  }
  onDateChange(date) {
    this.setState({ date });
  }
  render() {
    return (
      <div className="row">
        <Day onDateChange={this.onDateChange} />
        <div className="col-6">
          <h1>Add Shift</h1>
          <AddShiftForm date={this.state.date}/>
        </div>
      </div>
    );
  }
}

class Calendar extends Component {
  render() {
    return (
      <div>
        <Nav />
        <Switch>
          <Route path='/calendar/booking' component={Booking}/>
          <Route path='/calendar/rebooking' component={Rebooking}/>
          <Route path='/calendar/scheduling' component={Scheduling}/>
          <Route path='/calendar' exact render={() => (<Redirect to="/calendar/booking"/>)}/>
        </Switch>
      </div>
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/calendar.js